














































import { Component, Vue, Watch } from 'vue-property-decorator';
import { BaseResponseDTO } from '@/types';
import { MazList, MazListItem } from 'maz-ui';
@Component({ components: { MazList, MazListItem } })
export default class Home extends Vue {
  private settings = {
    quicktypenamespace: '',
    darkMode: true
  };

  private isSaving = false;
  private buttonText = 'Save';

  @Watch('computedSettings', { deep: true, immediate: true })
  onSettingsChange (): void {
    this.settings = this.computedSettings;
  }

  get computedSettings (): any {
    return this.$store.state.settings;
  }

  get endpoints (): BaseResponseDTO {
    return this.$store.state.endpoints;
  }

  async save () {
    this.isSaving = true;

    await this.$store.dispatch('saveSettings', this.settings).then(() => {
      this.isSaving = false;
      this.buttonText = 'Saved!';

      setTimeout(() => {
        this.buttonText = 'Save';
      }, 2000);
    });
  }

  getLink (path: string) {
    return `${window.location.origin}/${path}`;
  }
}
